const BUNDLEID = "com.app.closet.stylist";
// const APPSTOREID = '1345656565';
const APPSTOREID = "6444030686";

const DOMAINURIPREFIX = "https://vetir2.page.link";
const FALLBACK_URL = "https://apps.apple.com/in/app/v%C3%AAtir/id6444030686";

const PAYMENT_STATUS_CODE = {
    pending: "In process",
    failed: "Failed",
    success: "Success",
};

const ORDER_STATUS = {
    NOT_INITIATED: "Not initiated",
    PAYMENT_PROCESING: "In process",
    PAYMENT_FAILED: "Failed",
    PREPARING: "Preparing",
    BOUGHT_FROM_STORE: "Bought from Store",
    OUT_FOR_DELIVERY: "Out for Delivery",
    DELIVERED: "Delivered",
    CANCELED: "Cancelled",
    RETURNED: "Returned",
};

const ORDERING_CHANNEL = {
    ONLINE: "Online delivery",
    STORE: "In-store",
};

const JAVA_BASE_URL = process.env.EXPO_PUBLIC_JAVA_BASE_URL;
const NODE_BASE_URL = process.env.EXPO_PUBLIC_NODE_BASE_URL;

export const DELIVERY_TYPE = {
    STANDARD_DELIVERY: "Standard Delivery",
    EXPRESS_DELIVERY: "Express Delivery",
};

const SORT_OPTIONS = [
    {
        title: "New Arrivals",
        type: "latest",
        id: 1,
    },
    {
        title: "Price Low to High",
        type: "lowPrice",
        id: 2,
    },
    {
        title: "Price High to Low",
        type: "highPrice",
        id: 3,
    },
];

const FILTER_V2_IDS = {
    CATEGORY: 1,
    BRAND: 2,
    COLOR: 3,
    SIZE: 6,
    PRICE: 5,
    AVAILABILITY: 7,
    CLOTHING_SIZE: 8,
    SHOE_SIZE: 9,
    BRA_SIZE: 10,
};
export const StatusCodes = {
    SUCCESS: 200,
    CREATED: 201,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 400,
    TIME_OUT: 408,
};

export const categoryArr = {
    clothing: { categoryID: 1, id: 3, title: "Clothing", isSubCategory: true },
    shoes: { categoryID: 1, id: 5, title: "Shoes", isSubCategory: true },
    bags: { categoryID: 1, id: 2, title: "Bags", isSubCategory: true },
    "jewelry-&-watches": { categoryID: 1, id: 7, title: "Jewelry And Watches", isSubCategory: true },
    accessories: { categoryID: 1, id: 1, title: "Accessories", isSubCategory: true },
    beauty: { categoryID: 1, id: 9, title: "Beauty", isSubCategory: true },
    home: { categoryID: 1, id: 10, title: "Home", isSubCategory: true },
    grooming: { categoryID: 1, id: 11, title: "Grooming", isSubCategory: true },
    sport: { categoryID: 1, id: 6, title: "Sport", isSubCategory: true },
};

const IMAGE_PICKER_SMART_ALBUMS = [
    "UserLibrary",
    "PhotoStream",
    "Panoramas",
    "Videos",
    "Bursts",
    "CloudShared",
    "Imported",
    "Regular",
    "SyncedAlbum",
];

const TOUCH_ID_MODELS = [
    "iPhone 5s",
    "iPhone 6",
    "iPhone 6 Plus",
    "iPhone 6s",
    "iPhone 6s Plus",
    "iPhone SE (1st generation)",
    "iPhone 7",
    "iPhone 7 Plus",
    "iPhone 8",
    "iPhone 8 Plus",
    "iPhone SE (2nd generation)",
    "iPhone SE (3rd generation)",
    "iPhone SE",
];

const REGEX = {
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    name: /^[A-Za-z\s]{1,}[\.]{0,1}[A-Za-z\s]{0,}$/,
};

const FIREBASE_EVENT_NAMES = {
    PAGE_VIEW: "page_view",
    GENDER_SELECTION: "gender_selection",
    STORY_CLICKED: "story_clicked",
    SHOP_NOW_CLICKED: "shop_now_clicked",
    CATEGORY_CLICKED: "category_clicked",
    EDITORIAL_CLICKED: "editorial_clicked",
    POST_CLICKED: "post_clicked",
    INSTAGRAM_CLICKED: "instagram_clicked",
    NEWSLETTER_SUBSCRIBED: "newsletter_subscribed",
    EMAIL_CLICKED: "email_clicked",
    FOOTER_CLICKED: "footer_clicked",
    FILTER_CLICKED: "filter_clicked",
    PRODUCT_VIEWED: "product_viewed",
    ADD_TO_CART: "add_to_cart",
    ADD_TO_FAVOURITE: "add_to_favourite",
    FILTER_SELECTED: "filter_selected",
};

const FIREBASE_EVENT_PARAMS = {
    GENDER: "gender",
    PAGE_TITLE: "page_title",
    PAGE_LOCATION: "page_location",
    STORY_ID: "story_id",
    CLICKED_FROM: "clicked_from",
    CATEGORY_NAME: "category_name",
    EDITORIAL_ID: "editorial_id",
    POST_ID: "post_id",
    EMAIL: "email_id_of_subscriber",
    FILTER_NAME: "filter_name",
    PRODUCT_ID: "product_id",
};

const PAGES_ROUTES = {
    HOME: "/home",
    PRODUCTS: "/products",
    FAVORITES: "/favorites",
    ORDER_HISTORY: "/order-history",
    ORDER_DETAILS: "/order-details",
    ADDRESS_LIST: "/addresslist",
    PROFILE: "/profile",
    PDP: "/product",
    CHECKOUT: "/checkout",
    ORDER_SUMMARY: "/order-summary",
    PAYMENT: "/payment",
    STORIES_DETAILS: "/stories-details",
    CONTACT_US: "/contact-us",
};

const PAGES_TITLE = {
    HOME: "Home",
    PRODUCTS: "Products",
    FAVORITES: "Favorites",
    ORDER_HISTORY: "Order History",
    ORDER_DETAILS: "Order Details",
    ADDRESS_LIST: "Address List",
    PROFILE: "Profile",
    PDP: "PDP",
    CHECKOUT: "Checkout",
    ORDER_SUMMARY: "Order Summary",
    PAYMENT: "Payment",
    STORIES_DETAILS: "Stories Details",
    CONTACT_US: "Contact Us",
};

export {
    PAYMENT_STATUS_CODE,
    ORDER_STATUS,
    JAVA_BASE_URL,
    NODE_BASE_URL,
    FILTER_V2_IDS,
    IMAGE_PICKER_SMART_ALBUMS,
    BUNDLEID,
    APPSTOREID,
    DOMAINURIPREFIX,
    FALLBACK_URL,
    ORDERING_CHANNEL,
    TOUCH_ID_MODELS,
    REGEX,
    SORT_OPTIONS,
    FIREBASE_EVENT_NAMES,
    FIREBASE_EVENT_PARAMS,
    PAGES_ROUTES,
    PAGES_TITLE,
};
